const COMMON_FIELDS = {
  CREATED_AT: 'createdAt',
  ID: '_id',
  UPDATED_AT: 'updatedAt',
  VERSION: '__v',
};

export { COMMON_FIELDS };
